import React, { Component } from "react";
import Page from "Pages/_Layouts/DefaultInternal";
import useCompleoForm from "customHooks/useCompleoReactHookForm";
import useGetMetadata from "customHooks/useGetMetadata";
import { useTranslation } from "react-i18next";
import Loading from "customHooks/useCompleoReactHookForm/helpers/Loading";
import FormClassic from "customHooks/useCompleoReactHookForm/components/FormClassic";
import useFormStyles from "customHooks/useCompleoReactHookForm/components/useFormStyles";
import { useAuthState } from "_ReactContext/AuthContext";
import { useApi, useApiCache } from "customHooks/useApi";
import { useCancelButtonForm } from "customHooks/useCancelButtonForm";
import useValuesFromSource from "customHooks/useValuesFromSource";
import useEmailTemplate from "../../customHooks/useCompleoReactHookForm/Inputs/EmailDataV2/useEmailTemplate";

const EmailTemplateEdit = (props: any) => {
    const cancelFunction = useCancelButtonForm("/emailtemplate/list");

    // const [addProps, setAddProps] = React.useState<
    //     Compleo.useCompleoForm.AdditionalPropertiesField[]
    // >([]);

    const { company } = useAuthState();
    const moduleName = "EMAILTEMPLATEEDIT";
    const [t, i18n, readyTranslation] = useTranslation(moduleName, {
        useSuspense: false
    });

    const postAddressSearch = `/emailtemplate/search`;

    const [getEmailTemplateResult] = useApiCache(
        postAddressSearch,
        "post",
        { uuid: props.uuid, companyId: company.companyId },
        false
    );

    const postAddress = `/emailtemplate/edit`;

    const [editEmailTemplateReturn, editEmailTemplate] = useApi(
        postAddress,
        "post"
    );

    const [metadata] = useGetMetadata(moduleName);

    const [valuesFromSource] = useValuesFromSource(
        metadata,
        true,
        {},
        getEmailTemplateResult,
        ["data", "data", "Items"]
    );
    valuesFromSource.uuid = props.uuid;
    valuesFromSource.deleted = false;

    //return <div>Teste 1</div>;
    // let type = "";
    // if (getEmailTemplateResult.status === "success") {
    //     type = getEmailTemplateResult.response.data.data.Items[0].type;
    // }
    const type = (getEmailTemplateResult.response?.data?.data?.Items || [])[0]
        ?.type;
    const addProps: Compleo.useCompleoForm.AdditionalPropertiesField[] = [
        {
            fieldName: "template",
            props: {
                type: type
            }
        }
    ];

    // React.useEffect(() => {
    //     if (type) {
    //         const newAddProps = [...addProps];
    //         newAddProps.push({
    //             fieldName: "template",
    //             props: {
    //                 type: type
    //             }
    //         });
    //         setAddProps(newAddProps);
    //     }
    // }, [type]);

    // React.useEffect(() => {
    //     if (addProps.length > 0) {
    //         setAddProps([]);
    //     }
    // }, [i18n.languages[0]]);

    const ready =
        readyTranslation && getEmailTemplateResult.status === "success" && type;

    const [formCompleo, finished] = useCompleoForm({
        t,
        ready: ready,
        i18nV: i18n,
        postMethod: editEmailTemplate,
        postReturn: editEmailTemplateReturn,
        redirectAddress: "/emailtemplate/list",
        FormType: FormClassic,
        metadadosRetorno: metadata,
        valuesFromSource,
        secondaryButtonFunction: cancelFunction,
        additionalFieldProperties: addProps
    });

    let compRetorno: boolean | JSX.Element;
    compRetorno = <Loading />;
    const featureMainDescription = `${t("a_FeatureMainDescription")} - ${t(
        `typeEmail_${type}`
    )}`;

    if (ready) {
        compRetorno = formCompleo;
        return (
            <Page
                featureName={t("a_FeatureName")}
                featureMainDescription={featureMainDescription}
                maxWidth="md"
            >
                {compRetorno}
            </Page>
        );
    } else {
        return <Page>{compRetorno}</Page>;
    }
};

export default EmailTemplateEdit;
